import { Plugin } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { MenuItem } from './MenuItem';
import {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  paragraph,
  bold,
  em,
  strike,
  underline,
  superscript,
  blockquote,
  orderedList,
  unorderedList,
  link,
  iframe,
  image,
  undo,
  redo,
  clearFormatting
} from './menuItems';
import { topMenuPluginKey } from './keys';

class TopMenuView {
  items;
  editorView;
  name;
  updatedAt;
  constructor(items, editorView) {
    this.items = items;
    this.editorView = editorView;
    this.name = 'top-menu-plugin';
    this.updatedAt = Date.now();
  }

  update() {
    this.items = this.items.map((item) => {
      return { ...item, status: item.statusCheck && item.statusCheck(this.editorView.state) };
    });

    this.updatedAt = Date.now(); // TODO: only updated timestamp when items have changed?
  }

  destroy() {
    /* noop */
  }
}

export default (schema) => {
  return new Plugin({
    key: topMenuPluginKey,
    view(editorView) {
      const items = [
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        paragraph,
        bold,
        em,
        strike,
        underline,
        superscript,
        blockquote,
        undo,
        redo,
        link,
        iframe,
        image,
        orderedList,
        unorderedList,
        clearFormatting
      ];

      return new TopMenuView(items, editorView);
    }
  });
};



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/plugins/TopMenuPlugin.js